import React, {useState} from 'react';
import classes from './style.module.css';
import PropTypes from 'prop-types';
import {logInfo/*, logError*/} from '../../../util/log/logger'
import { Form, Button, Row } from 'react-bootstrap';

import { CHANGE_PASSWORD_FORM_FIELDS } from '../../../constants/Constants'

const ChangePasswordForm = props => {

    const [password, setPassword] = useState("");
    const [passwordNew, setPasswordNew] = useState("");
    const [passwordNewVerify, setPasswordNewVerify] = useState("");
    const [inputErrorMessage, setInputErrorMessage] = useState(null);


    const compareInputs = () => {
        return passwordNew === passwordNewVerify && props.password === password
    }

    const changePasswordHandler = async () => {
        logInfo("changePasswordHandler called.")
        if(compareInputs()) {
            logInfo("changePasswordHandler | new and confirm passwords matched")
            setInputErrorMessage(null)
            await props.changePasswordClicked(passwordNew)
        }else {
            logInfo("changePasswordHandler | mismatch in new and confirm passwords")
            setInputErrorMessage("Incorrect passwords. Please check and re-enter again")
        }
    }

    let fieldErrors = null;
    if(inputErrorMessage) {
        fieldErrors = <Row className={classes.FieldErrors}>
                        <p>{inputErrorMessage}</p>
                      </Row>
    }

    return (
        <Form className={classes.ChangePasswordForm}>
            <h2 className={classes.Title}>{props.title}</h2>
            <p className={classes.InfoText}>Password minimum length is 8 and should adhere to the password policy.</p>
            <Form.Group controlId="loginFormPasswordInput" className={classes.FormGroup}>
                <Form.Label className={classes.FormLabel}>{CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_TEXT.label}</Form.Label>
                <Form.Control
                    key={CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_TEXT.key}
                    type="password"
                    placeholder={CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_TEXT.placeholder}
                    value={password}
                    className={classes.FormControl}
                    onChange={(event) => { setPassword(event.target.value) }} />
            </Form.Group>

            <Form.Group controlId="loginFormPasswordInputNew" className={classes.FormGroup}>
                <Form.Label className={classes.FormLabel}>{CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_NEW_TEXT.label}</Form.Label>
                <Form.Control
                    key={CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_NEW_TEXT.key}
                    type="password"
                    placeholder={CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_NEW_TEXT.placeholder}
                    value={passwordNew}
                    className={classes.FormControl}
                    onChange={(event) => { setPasswordNew(event.target.value); setInputErrorMessage(null) }} />
            </Form.Group>

            <Form.Group controlId="loginFormPasswordInputNewVerify" className={classes.FormGroup}>
                <Form.Label className={classes.FormLabel}>{CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_NEW_VERIFY_TEXT.label}</Form.Label>
                <Form.Control
                    key={CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_NEW_VERIFY_TEXT.key}
                    type="password"
                    placeholder={CHANGE_PASSWORD_FORM_FIELDS.PASSWORD_NEW_VERIFY_TEXT.placeholder}
                    value={passwordNewVerify}
                    className={classes.FormControl}
                    onChange={(event) => { setPasswordNewVerify(event.target.value); setInputErrorMessage(null) }} />
            </Form.Group>
            {fieldErrors}
            <Button
                className={classes.SubmitButton}
                onClick={changePasswordHandler}>
                {CHANGE_PASSWORD_FORM_FIELDS.CHANGE_PASSWORD_BUTTON.label}
            </Button>
        </Form>
    )
}

ChangePasswordForm.propTypes = {
    password: PropTypes.string.isRequired,
    changePasswordClicked: PropTypes.func.isRequired
}

export default ChangePasswordForm